import { RefUI, createRefInstances } from "./refUI";
import Cookies from 'js-cookie';

class RefGP {
  public constructor(private ui: RefUI) {
    if (this.isClosed()) {
      this.ui.destroy();
    } else {
      this.ui.show();
      // Add eventlistner
      this.ui.onClose(this.handleClose.bind(this));
    }

  }

  private handleClose() : void {
    this.writeCookie();
    this.ui.destroy();
  }

  private getNotificationCookie() : any {
    if (typeof Cookies.get('closedNotifications') !== 'undefined' && Cookies.get('closedNotifications') && Cookies.get('closedNotifications') !== '') {
      return JSON.parse(decodeURIComponent(Cookies.get('closedNotifications')));
    }
    return [];
  }

  private writeCookie() : void {
    const id = this.ui.getId();
    const cookie = this.getNotificationCookie();
    cookie.push(id);
    Cookies.set('closedNotifications', JSON.stringify(cookie), {
      path: window.cookiePath,
      domain: window.cookieDomain,
      sameSite: 'Strict'
    });
  }

  private isClosed() : boolean {
    const filter = this.getNotificationCookie().filter((val) => val === this.ui.getId());
    return filter.length > 0;
  }
}

export function initRef() {
  return createRefInstances().map((ui: RefUI) => {
    return new RefGP(ui);
  });
}
